export const t_global_breakpoint_md = {
  "name": "--pf-t--global--breakpoint--md",
  "value": "48rem",
  "var": "var(--pf-t--global--breakpoint--md)"
};
export default t_global_breakpoint_md;